export class TextEditor {
  constructor(controller) {
    this.controller = controller;
    this.currentEditingElement = null;
    this.originalContent = null;
    this.eventListeners = [];
    // For image modal
    this.currentImageElement = null;
    // For link modal
    this.currentLinkElement = null;
  }

  initializeTextEditor() {
    document.body.classList.add('text-editor');
    this.addCombinedDoubleClickHandler();
    this.addColorChangeControls();
    this.initializeImageModalHandlers();
    this.initializeLinkModalHandlers();
    this.preventLinkClicks();
  }

  // Utility to check if an element is inside .container-fluid
  isInsideContainerFluid(element) {
    while (element && element !== document.body) {
      if (element.classList && element.classList.contains('container-fluid')) {
        return true;
      }
      element = element.parentElement;
    }
    return false;
  }

  // --- Combined double-click handler for both text and images ---
  addCombinedDoubleClickHandler() {
    this.combinedDoubleClickHandler = (event) => {
      // Prevent handler if inside .container-fluid
      if (this.isInsideContainerFluid(event.target)) return;

      console.log('Double-click detected on:', event.target);

      // Try to find an image under mouse
      const imageElement = this.findImageUnderMouse(event);
      console.log('Image under mouse:', imageElement);

      if (imageElement) {
        event.preventDefault();
        event.stopPropagation();
        this.currentImageElement = imageElement;
        this.showImageModal(imageElement);
        return;
      }

      // --- NEW: Check for <a> link editing ---
      const target = event.target;
      if (target.tagName === 'A') {
        event.preventDefault();
        event.stopPropagation();
        this.currentLinkElement = target;
        this.showLinkModal(target);
        return;
      }

      // If not image or link, check for text editing
      if (this.hasPlainText(target) && !this.isCurrentlyEditing(target)) {
        event.preventDefault();
        event.stopPropagation();
        this.makeElementEditable(target);
      }
    };

    document.addEventListener('dblclick', this.combinedDoubleClickHandler, true);

    this.eventListeners.push({
      element: document,
      event: 'dblclick',
      handler: this.combinedDoubleClickHandler,
      options: true
    });
  }

  // --- Image modal logic (from image_change_handler.js) ---
  initializeImageModalHandlers() {
    // Modal for image change
    this.imageModal = document.querySelector('.image-modal');
    if (!this.imageModal) return;

    // Close modal button
    const closeModal = this.imageModal.querySelector('.close-modal');
    if (closeModal) {
      closeModal.addEventListener('click', () => {
        this.imageModal.style.display = 'none';
      });
    }

    // Close modal when clicking outside
    window.addEventListener('click', (e) => {
      if (e.target === this.imageModal) {
        this.imageModal.style.display = 'none';
      }
    });

    // Preview functionality for URL input
    const imageUrlInput = document.getElementById('image-url');
    if (imageUrlInput) {
      imageUrlInput.addEventListener('input', function () {
        const url = this.value.trim();
        const previewImage = document.getElementById('preview-image');
        if (previewImage) {
          if (url) {
            previewImage.src = url;
            previewImage.style.display = 'block';
            previewImage.onerror = function () {
              previewImage.style.display = 'none';
            };
          } else {
            this.clearPreviewImage();
          }
        }
      }.bind(this));
    }

    // Apply button
    const applyBtn = this.imageModal.querySelector('.btn-apply-image');
    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        if (!this.currentImageElement) return;
        const urlInput = document.getElementById('image-url').value.trim();
        // const fileInput = document.getElementById('image-upload')?.files[0];
        console.log('Applying image change with URL:', urlInput);

        if (urlInput) {
          this.currentImageElement.src = urlInput;
          this.imageModal.style.display = 'none';
        }
        // else if (fileInput) {
        //   const reader = new FileReader();
        //   reader.onload = (e) => {
        //     this.currentImageElement.src = e.target.result;
        //     this.imageModal.style.display = 'none';
        //   };
        //   reader.readAsDataURL(fileInput);
        // }
      });
    }

    // Card click to copy image URL
    document.querySelectorAll('div.storage-card').forEach(card => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const img = card.querySelector('img');
        if (img && img.src) {
          const imageUrlInput = document.getElementById('image-url');
          if (imageUrlInput) {
            imageUrlInput.value = img.src;
            const previewImage = document.getElementById('preview-image');
            if (previewImage) {
              previewImage.src = img.src;
              previewImage.style.display = 'block';
            }
          }
        }

        // Scroll modal content to top after selecting image
        if (this.imageModal) {
          this.imageModal.scrollTop = 0;
          const modalContent = this.imageModal.querySelector('.modal-content');
          if (modalContent) {
            modalContent.scrollTop = 0;
          }
        }
      });
    });

    // For external image selection events
    document.addEventListener('image:selected', (event) => {
      const imagePath = event.detail.path;
      if (this.currentImageElement) {
        this.currentImageElement.src = imagePath;
        this.currentImageElement = null;
      }
    });
  }

  clearPreviewImage() {
    const previewImage = document.getElementById('preview-image');
    if (previewImage) {
      previewImage.src = '';
      previewImage.style.display = 'none';
    }
  }

  showImageModal(imageElement) {
    // Prevent handler if inside .container-fluid
    if (this.isInsideContainerFluid(imageElement)) return;
    if (!this.imageModal) return;
    // Clear previous values
    const imageUrlInput = document.getElementById('image-url');
    if (imageUrlInput) imageUrlInput.value = '';
    this.clearPreviewImage();
    this.imageModal.style.display = 'block';

    // Scroll modal content to top
    this.imageModal.scrollTop = 0;
    const modalContent = this.imageModal.querySelector('.modal-content');
    if (modalContent) {
      modalContent.scrollTop = 0;
    }
  }

  // --- Link modal logic ---
  initializeLinkModalHandlers() {
    // Create modal if not present
    if (!document.getElementById('link-edit-modal')) {
      const modal = document.createElement('div');
      modal.id = 'link-edit-modal';
      modal.style.cssText = `
        display: none;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: white;
        border: 1px solid #ccc;
        border-radius: 8px;
        z-index: 10001;
        padding: 20px;
        box-shadow: 0 4px 16px rgba(0,0,0,0.15);
        min-width: 280px;
      `;
      modal.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
          <span style="font-weight:bold;font-size:14px;">Изменить ссылку</span>
          <button id="close-link-modal" style="background:none;border:none;font-size:18px;cursor:pointer;">×</button>
        </div>
        <div style="margin-bottom:10px;">
          <label style="font-size:12px;">Текст:</label>
          <input id="link-edit-text" type="text" style="width:100%;margin-top:2px;padding:4px 6px;border-radius:4px;border:1px solid #ccc;">
        </div>
        <div style="margin-bottom:14px;">
          <label style="font-size:12px;">URL:</label>
          <input id="link-edit-url" type="text" style="width:100%;margin-top:2px;padding:4px 6px;border-radius:4px;border:1px solid #ccc;">
        </div>
        <div style="display:flex;gap:8px;justify-content:flex-end;">
          <button id="apply-link-edit" style="padding:6px 14px;border-radius:4px;border:none;background:#007bff;color:white;cursor:pointer;">Применить</button>
          <button id="cancel-link-edit" style="padding:6px 14px;border-radius:4px;border:none;background:#6c757d;color:white;cursor:pointer;">Отмена</button>
        </div>
      `;
      document.body.appendChild(modal);
    }

    this.linkModal = document.getElementById('link-edit-modal');
    if (!this.linkModal) return;

    // Close modal button
    const closeModal = this.linkModal.querySelector('#close-link-modal');
    if (closeModal) {
      closeModal.addEventListener('click', () => {
        this.linkModal.style.display = 'none';
        this.currentLinkElement = null;
      });
    }

    // Cancel button
    const cancelBtn = this.linkModal.querySelector('#cancel-link-edit');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        this.linkModal.style.display = 'none';
        this.currentLinkElement = null;
      });
    }

    // Apply button
    const applyBtn = this.linkModal.querySelector('#apply-link-edit');
    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        if (!this.currentLinkElement) return;
        const textInput = this.linkModal.querySelector('#link-edit-text');
        const urlInput = this.linkModal.querySelector('#link-edit-url');
        if (textInput && urlInput) {
          this.currentLinkElement.textContent = textInput.value;
          this.currentLinkElement.href = urlInput.value;
        }
        this.linkModal.style.display = 'none';
        this.currentLinkElement = null;
      });
    }
  }

  showLinkModal(linkElement) {
    // Prevent handler if inside .container-fluid
    if (this.isInsideContainerFluid(linkElement)) return;
    if (!this.linkModal) return;
    // Set current values
    const textInput = this.linkModal.querySelector('#link-edit-text');
    const urlInput = this.linkModal.querySelector('#link-edit-url');
    if (textInput) textInput.value = linkElement.textContent || '';
    if (urlInput) urlInput.value = linkElement.getAttribute('href') || '';
    this.linkModal.style.display = 'block';
    // Focus text input
    setTimeout(() => { textInput && textInput.focus(); }, 100);
  }

  // --- Helper to find image under mouse (from image_change_handler.js) ---
  findImageUnderMouse(event) {
    const elementsUnderPoint = document.elementsFromPoint(event.clientX, event.clientY);
    if (event.target.tagName === 'IMG') {
      return event.target;
    }
    for (let elem of elementsUnderPoint) {
      if (elem.tagName === 'IMG') {
        return elem;
      }
    }
    return null;
  }

  cleanup() {
    console.log('Cleaning up TextEditor...');
    this.eventListeners.forEach(({ element, event, handler, options }) => {
      if (element && element.removeEventListener) {
        element.removeEventListener(event, handler, options);
      }
    });
    this.eventListeners = [];
    if (this.currentEditingElement) {
      this.finishEditing(this.currentEditingElement);
    }
    this.hideColorPicker();
    document.body.classList.remove('text-editor');
    this.currentEditingElement = null;
    this.originalContent = null;
    this.combinedDoubleClickHandler = null;
    // Hide image modal if open
    if (this.imageModal) this.imageModal.style.display = 'none';
    this.currentImageElement = null;
    // Hide link modal if open
    if (this.linkModal) this.linkModal.style.display = 'none';
    this.currentLinkElement = null;
  }

  hasPlainText(element) {
    // Check if element has text content and is not an input, textarea, or already contenteditable
    const textContent = element.textContent?.trim();
    const tagName = element.tagName.toLowerCase();

    return textContent &&
      textContent.length > 0 &&
      !['input', 'textarea', 'select', 'button', 'section'].includes(tagName) &&
      element.contentEditable !== 'true';
  }

  isCurrentlyEditing(element) {
    return element === this.currentEditingElement || element.contentEditable === 'true';
  }

  makeElementEditable(element) {
    // Prevent handler if inside .container-fluid
    if (this.isInsideContainerFluid(element)) return;
    // Store the original content
    this.originalContent = element.innerHTML;
    this.currentEditingElement = element;

    // Make the element editable
    element.contentEditable = true;
    element.focus();

    // Add visual indication that it's being edited
    element.style.outline = '2px dashed #007bff';
    element.style.backgroundColor = '#f8f9fa';

    // Select all text
    this.selectAllText(element);

    // Add color picker controls
    this.showColorPicker(element);

    // Add event listeners for finishing editing
    this.addEditingEventListeners(element);
  }

  selectAllText(element) {
    const range = document.createRange();
    range.selectNodeContents(element);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  addEditingEventListeners(element) {
    // Finish editing on Enter key (but allow Shift+Enter for new lines)
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.finishEditing(element);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        this.cancelEditing(element);
      }
    };

    // Finish editing when clicking outside
    const handleClickOutside = (event) => {
      if (!element.contains(event.target) && !this.isColorPickerElement(event.target)) {
        this.finishEditing(element);
      }
    };

    // Finish editing when losing focus
    const handleBlur = (event) => {
      // Delay to allow color picker interactions
      setTimeout(() => {
        if (document.activeElement !== element && !this.isColorPickerElement(document.activeElement)) {
          this.finishEditing(element);
        }
      }, 100);
    };

    element.addEventListener('keydown', handleKeyDown);
    document.addEventListener('click', handleClickOutside);
    element.addEventListener('blur', handleBlur);

    // Store event listeners for cleanup
    element._editingListeners = {
      keydown: handleKeyDown,
      click: handleClickOutside,
      blur: handleBlur
    };
  }

  finishEditing(element) {
    if (element !== this.currentEditingElement) return;

    // Remove editing styles
    element.contentEditable = false;
    element.style.outline = '';
    element.style.backgroundColor = '';

    // Remove event listeners
    if (element._editingListeners) {
      element.removeEventListener('keydown', element._editingListeners.keydown);
      document.removeEventListener('click', element._editingListeners.click);
      element.removeEventListener('blur', element._editingListeners.blur);
      delete element._editingListeners;
    }

    // Hide color picker
    this.hideColorPicker();

    // Clear current editing state
    this.currentEditingElement = null;
    this.originalContent = null;

    // Show success message
    // if (this.controller.showToaster) {
    //   this.controller.showToaster('Text updated successfully!');
    // }
  }

  cancelEditing(element) {
    if (element !== this.currentEditingElement) return;

    // Restore original content
    element.innerHTML = this.originalContent;

    // Finish editing
    this.finishEditing(element);

    // Show cancellation message
    if (this.controller.showToaster) {
      this.controller.showToaster('Edit cancelled');
    }
  }

  addColorChangeControls() {
    // This method sets up the color picker functionality
    // The actual color picker will be created dynamically when needed
  }

  showColorPicker(element) {
    // Prevent handler if inside .container-fluid
    if (this.isInsideContainerFluid(element)) return;
    // Remove existing color picker
    this.hideColorPicker();

    // Create color picker container
    const colorPicker = document.createElement('div');
    colorPicker.id = 'text-color-picker';
    colorPicker.style.cssText = `
      position: absolute;
      background: white;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 10px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 200px;
    `;

    // Position the color picker near the element (account for scroll)
    const rect = element.getBoundingClientRect();
    const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    colorPicker.style.left = `${rect.left + scrollX}px`;
    colorPicker.style.top = `${rect.bottom + scrollY + 10}px`;

    // Add header with title and close button
    const header = document.createElement('div');
    header.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: center;
    `;

    const title = document.createElement('div');
    title.textContent = 'Text Color:';
    title.style.fontWeight = 'bold';
    title.style.fontSize = '12px';

    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.cssText = `
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      color: #666;
    `;
    closeButton.title = 'Close editing';

    closeButton.addEventListener('mouseenter', () => {
      closeButton.style.backgroundColor = '#f0f0f0';
    });

    closeButton.addEventListener('mouseleave', () => {
      closeButton.style.backgroundColor = 'transparent';
    });

    closeButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.finishEditing(element);
    });

    header.appendChild(title);
    header.appendChild(closeButton);
    colorPicker.appendChild(header);

    // Add color options
    const colors = [
      { name: 'Black', value: '#000000' },
      { name: 'Red', value: '#dc3545' },
      { name: 'Blue', value: '#007bff' },
      { name: 'Green', value: '#28a745' },
      { name: 'Orange', value: '#fd7e14' },
      { name: 'Purple', value: '#6f42c1' },
      { name: 'Teal', value: '#20c997' },
      { name: 'Gray', value: '#6c757d' }
    ];

    const colorContainer = document.createElement('div');
    colorContainer.style.cssText = `
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 5px;
    `;

    colors.forEach(color => {
      const colorButton = document.createElement('button');
      colorButton.style.cssText = `
        width: 30px;
        height: 30px;
        border: 2px solid #ddd;
        border-radius: 4px;
        background-color: ${color.value};
        cursor: pointer;
        transition: transform 0.1s;
      `;
      colorButton.title = color.name;

      colorButton.addEventListener('mouseenter', () => {
        colorButton.style.transform = 'scale(1.1)';
      });

      colorButton.addEventListener('mouseleave', () => {
        colorButton.style.transform = 'scale(1)';
      });

      colorButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.changeTextColor(element, color.value);
      });

      colorContainer.appendChild(colorButton);
    });

    colorPicker.appendChild(colorContainer);

    // Add custom color input
    const customColorContainer = document.createElement('div');
    customColorContainer.style.cssText = `
      display: flex;
      align-items: center;
      gap: 8px;
    `;

    const customLabel = document.createElement('label');
    customLabel.textContent = 'Custom:';
    customLabel.style.fontSize = '12px';

    const customColorInput = document.createElement('input');
    customColorInput.type = 'color';
    customColorInput.style.cssText = `
      width: 40px;
      height: 30px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    `;

    customColorInput.addEventListener('change', (e) => {
      this.changeTextColor(element, e.target.value);
    });

    customColorContainer.appendChild(customLabel);
    customColorContainer.appendChild(customColorInput);
    colorPicker.appendChild(customColorContainer);

    document.body.appendChild(colorPicker);
  }

  changeTextColor(element, color) {
    // Prevent handler if inside .container-fluid
    if (this.isInsideContainerFluid(element)) return;
    element.style.color = color;

    // Add highlight animation
    element.classList.add('text-change-animation');
    setTimeout(() => {
      element.classList.remove('text-change-animation');
    }, 500);

    // if (this.controller.showToaster) {
    //   this.controller.showToaster(`Text color changed to ${color}`);
    // }
  }

  hideColorPicker() {
    const existingPicker = document.getElementById('text-color-picker');
    if (existingPicker) {
      existingPicker.remove();
    }
  }

  isColorPickerElement(element) {
    const colorPicker = document.getElementById('text-color-picker');
    return colorPicker && (colorPicker.contains(element) || element === colorPicker);
  }

  preventLinkClicks() {
    // Prevent navigation for all <a> while editor is active
    this.linkClickHandler = (event) => {
      // Prevent handler if inside .container-fluid
      if (this.isInsideContainerFluid(event.target)) return;
      if (event.target.tagName === 'A') {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    document.addEventListener('click', this.linkClickHandler, true);
    this.eventListeners.push({
      element: document,
      event: 'click',
      handler: this.linkClickHandler,
      options: true
    });
  }
}
